import { useContext } from 'react';
import { ThemeModeButton } from 'hive-mui-utils';
import { DataContext } from '../contexts';

export function HeaderMenuControls(): JSX.Element {
  const { featureFlags } = useContext(DataContext);

  return <ThemeModeButton supported={featureFlags.supportDarkMode} />;
}
